// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"40":"add","391":"div","435":"sub","971":"mul"}[chunkId] || chunkId) + "." + {"40":"1a47b221","391":"2e37eb0d","435":"12a22396","528":"93ea01a8","971":"be7ad567"}[chunkId] + ".js";
};